import { Component, Input, OnInit } from '@angular/core';
import { InvoiceInterface, InvoiceStatus } from '@contracts/interfaces/invoice.interface';
import { InvoiceComponent } from '../invoice';

@Component({
  selector: 'app-invoice-ebay-new-design',
  templateUrl: './invoice-ebay-new-design.component.html',
  styleUrls: ['./invoice-ebay-new-design.component.scss', '../../pages/invoice-table.scss']
})
export class InvoiceEbayNewDesignComponent extends InvoiceComponent implements OnInit {
  @Input()
  invoice: InvoiceInterface;

  defaultInvoice = {
    type: "ebay-new-design",
    status: InvoiceStatus.Unpaid,
    customer: null,
    number: null,
    custom: "",
    dateCreated: new Date(),
    dateDue: new Date(),
    subTotal: 0,
    total: 0,
    paymentsMade: [],
    pdf: {
      file: "invoice-ebay-new-design"
    },
    lineItems: [
      {
        item: '',
        desc: '',
        qty: 1,
        price: 0
      }
    ],
    gst: 0,
    isGSTIncluded: true,
    communicationLog: []
  }
}
